/*
 * Transforma "Frete", "Cashback" e "Cupom" em abas: um título ao lado do outro,
 * só um painel aberto por vez.
 *
 * Os dois blocos vêm de lugares diferentes e não podem ser tratados igual:
 *
 *   - Frete é do tema: um <details> com <summary>, aberto pelo atributo `open`.
 *   - Cashback é injetado em tempo de execução pelo Fidelizar Mais: divs com IDs
 *     `fm-*`, alternadas por um clique no título que mexe no display por estilo
 *     inline. Não é <details> e não responde a CSS comum.
 *
 * POR QUE ESTE ARQUIVO NÃO ENCOSTA NOS NÓS DO APP
 *
 * A primeira versão punha classes no bloco do app e o movia para junto do
 * <details>. O app redesenha esse bloco sozinho a cada mudança no carrinho, e aí
 * classe e posição se perdiam — as abas tinham que ser remontadas, quando não
 * ficavam de vez como dois accordions soltos.
 *
 * Agora o JS faz só duas coisas, ambas nos nós do PRÓPRIO tema:
 *   1. insere a faixa de abas logo depois do aviso de cupom;
 *   2. escreve o estado (`sdn-tabs--frete` / `sdn-tabs--cashback`) no
 *      .ec-cart-footer__content, que o re-render do drawer não substitui.
 *
 * Quem mostra e esconde os painéis é o CSS, mirando os IDs `fm-*` e o
 * <details>. Como IDs não mudam quando o app redesenha, o resultado continua
 * valendo sem ninguém precisar remontar nada.
 */
(function () {
  'use strict';

  var FRETE = '#ec-cart-drawer-frete-details';
  var CASHBACK = '#fm-body-wrapper';
  var CUPOM = '.sdn-cupom';
  var CONTAINER = '.ec-cart-footer__content';
  var ABA_ATUAL = 'frete';

  function aplicarEstado(container, frete) {
    container.classList.toggle('sdn-tabs--frete', ABA_ATUAL === 'frete');
    container.classList.toggle('sdn-tabs--cashback', ABA_ATUAL === 'cashback');
    container.classList.toggle('sdn-tabs--cupom', ABA_ATUAL === 'cupom');

    // O <details> só revela o conteúdo com `open`; o CSS cuida do resto.
    if (frete) frete.open = ABA_ATUAL === 'frete';

    var faixa = container.querySelector('.sdn-cart-tabs');
    if (!faixa) return;
    Array.prototype.forEach.call(faixa.querySelectorAll('.sdn-cart-tabs__btn'), function (b) {
      var ativo = b.dataset.aba === ABA_ATUAL;
      b.classList.toggle('sdn-cart-tabs__btn--ativo', ativo);
      b.setAttribute('aria-selected', ativo ? 'true' : 'false');
    });
  }

  function criarFaixa() {
    var faixa = document.createElement('div');
    faixa.className = 'sdn-cart-tabs';
    faixa.setAttribute('role', 'tablist');

    /* Três abas em vez de duas, e sem ícone: com um terço da largura cada, o
       ícone comprimia o rótulo. Por isso os nomes também encurtaram. */
    [
      { chave: 'frete', rotulo: 'Frete' },
      { chave: 'cashback', rotulo: 'Cashback' },
      { chave: 'cupom', rotulo: 'Cupom' },
    ].forEach(function (item) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sdn-cart-tabs__btn';
      b.dataset.aba = item.chave;
      b.setAttribute('role', 'tab');
      b.textContent = item.rotulo;
      faixa.appendChild(b);
    });

    // Um listener na faixa serve os dois botões e sobrevive a qualquer troca.
    faixa.addEventListener('click', function (evento) {
      var botao = evento.target.closest('.sdn-cart-tabs__btn');
      if (!botao) return;
      ABA_ATUAL = botao.dataset.aba;
      var container = faixa.closest(CONTAINER);
      if (container) aplicarEstado(container, container.querySelector(FRETE));
    });

    return faixa;
  }

  /* Idempotente de propósito: quando já está tudo no lugar não escreve nada no
     DOM, então pode ser chamada a cada mutação sem causar piscada. */
  /* `a` vem antes de `b` na ordem do documento? */
  function vemAntes(a, b) {
    return !!(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  /* Idempotente de propósito: quando já está tudo no lugar não escreve nada no
     DOM, então pode ser chamada a cada mutação sem causar piscada. */
  function sincronizar() {
    var container = document.querySelector(CONTAINER);
    if (!container) return;

    var frete = container.querySelector(FRETE);
    var cashback = container.querySelector(CASHBACK);
    var cupom = container.querySelector(CUPOM);

    /* O frete é do tema e sempre existe; cashback vem de app e cupom é nosso.
       Sem pelo menos dois painéis não há o que abainhar, e cada bloco volta a
       funcionar sozinho. */
    var paineis = [frete, cashback, cupom].filter(Boolean);
    if (!frete || paineis.length < 2) {
      container.classList.remove('sdn-tabs--frete', 'sdn-tabs--cashback', 'sdn-tabs--cupom');
      var orfa = container.querySelector('.sdn-cart-tabs');
      if (orfa) orfa.parentNode.removeChild(orfa);
      return;
    }

    var faixa = container.querySelector('.sdn-cart-tabs');

    /* A faixa tem que ficar acima de TODOS os painéis. Descobrimos qual deles
       aparece primeiro no DOM em vez de fixar uma âncora: o bloco do app é
       injetado por terceiro e a ordem muda quando ele se redesenha. */
    var primeiro = paineis[0];
    paineis.forEach(function (p) {
      if (vemAntes(p, primeiro)) primeiro = p;
    });

    if (!faixa) {
      faixa = criarFaixa();
      container.insertBefore(faixa, primeiro);
    } else if (vemAntes(primeiro, faixa)) {
      /* Quem se move é a FAIXA, nó nosso — reposicionar o bloco do app seria
         desfeito no próximo redesenho dele. Idempotente: uma vez certo, não repete. */
      container.insertBefore(faixa, primeiro);
    }

    aplicarEstado(container, frete);
  }

  /* O app injeta o bloco depois do carregamento, e o drawer se redesenha a cada
     mudança no carrinho. Observar o DOM cobre os dois casos sem ficar tentando
     adivinhar o tempo certo. */
  var observador = new MutationObserver(sincronizar);

  function iniciar() {
    sincronizar();
    observador.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:dom-updated', sincronizar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
